import ApiResponseDisplayer from '@components/ApiResponseDisplayer';
import RegisterBtnComponent from '@components/Default/Register/RegisterBtnComponent';
import SearchComponent from '@components/Default/Search/SearchComponent';
import LinkedComponent from '@components/LinkedComponent';
import Page from '@components/Page';
import IPagination from '@interfaces/IPagination';
import { Product } from '@interfaces/IProduct';
import { IProductionLine } from '@interfaces/IProductionLine';
import { IWorkstation } from '@interfaces/Workstation';
import AppContext from '@services/Context';
import ProductService from '@services/Product';
import ProductionLineService from '@services/ProductionLine';
import WorkstationService from '@services/Workstation';
import NotificationComponent from '@src/helpers/_showNotifications';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Avatar, Button, Col, Form, Input, Modal, Row } from 'antd';
import _ from 'lodash';
import findIndex from 'lodash/findIndex';
import React, { Component } from 'react';

import Table from '../components/TableComponent';

interface ProductionLineContainerProps {
  match: any,
  form: any,
}
interface ProductionLineContainerState {
  serverResponse: any;
  search: string;
  isLoading: boolean;
  showFormModal: boolean;
  loadingRequest: boolean;
  tableData: IProductionLine[];
  editItem?: IProductionLine;
  selectProducts: any[];
  productsItems: any;
  productionLineID: string;
  //STATE PRODUCT LINKED
  productionLineProducts: string[];
  showProductsModal: boolean;
  searchAvailableProducts: string;
  searchSavedProducts: string;
  loadingAvailableProducts: boolean;
  loadingSavedProducts: boolean;
  availableProductsData: IProductionLine[];
  savedProductsData: any[];
  availableProductsAmount: number;
  savedProductsAmount: number;
  loadingMoreAvailableProducts: boolean;
  loadingMoreSavedProducts: boolean;
  // STAte WORKSTATION LINKED
  productionLineWorkstations: string[];
  showWorkstationModal: boolean;
  searchAvailableWorkstations: string;
  searchSavedWorkstations: string;
  loadingAvailableWorkstations: boolean;
  loadingSavedWorkstations: boolean;
  availableWorkstationsData: IProductionLine[];
  savedWorkstationsData: any[];
  availableWorkstationsAmount: number;
  savedWorkstationsAmount: number;
  loadingMoreAvailableWorkstations: boolean;
  loadingMoreSavedWorkstations: boolean;
  offset: string;
}

const tableColumns = [{
  title: 'form.labels.code',
  dataIndex: 'code',
  key: 'code',
},
{
  title: 'titles.products',
  dataIndex: 'products',
  key: 'products',
}, {
  title: 'common.stations',
  dataIndex: 'workstations',
  key: 'workstations',
},
{
  title: 'table.actions',
  dataIndex: 'action',
  key: 'action',
  width: '30%',
}];

const productsAvailableTableColumns = [
  {
    title: 'form.labels.code',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const productsSavedTableColumns = [
  {
    title: 'form.labels.code',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  },
];

const workstationsAvailableTableColumns = [
  {
    title: 'form.labels.code',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const workstationsSavedTableColumns = [
  {
    title: 'form.labels.code',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  },
];

const FormItem = Form.Item;
const productionLineService: ProductionLineService = new ProductionLineService();
const productsService: ProductService = new ProductService();
const workstationService: WorkstationService = new WorkstationService();
export default class ProductionLineContainer extends Component<ProductionLineContainerProps, ProductionLineContainerState> {

  private unit: string = '';
  private LinkedRef: any;

  constructor(props: any) {
    super(props);

    this.LinkedRef = React.createRef();

    this.state = {
      isLoading: true,
      showFormModal: false,
      tableData: [],
      search: '',
      editItem: {
        id: '',
        code: '',
        products: '' || undefined,
        workstations: '' || undefined
      },
      serverResponse: undefined,
      loadingRequest: false,
      selectProducts: [''],
      productsItems: '',
      productionLineID: '',
      //STATE PRODUCT LINKED
      productionLineProducts: [''],
      searchAvailableProducts: '',
      showProductsModal: false,
      searchSavedProducts: '',
      loadingAvailableProducts: false,
      loadingSavedProducts: false,
      availableProductsData: [],
      savedProductsData: [],
      availableProductsAmount: 0,
      savedProductsAmount: 0,
      loadingMoreAvailableProducts: false,
      loadingMoreSavedProducts: false,
      //STATE WWORKSTATION LINKED
      productionLineWorkstations: [''],
      searchAvailableWorkstations: '',
      showWorkstationModal: false,
      searchSavedWorkstations: '',
      loadingAvailableWorkstations: false,
      loadingSavedWorkstations: false,
      availableWorkstationsData: [],
      savedWorkstationsData: [],
      availableWorkstationsAmount: 0,
      savedWorkstationsAmount: 0,
      loadingMoreAvailableWorkstations: false,
      loadingMoreSavedWorkstations: false,
      offset:''
    };
  }

  setUnit(unit: string) {
    this.unit = unit;
  }

  componentDidMount() {
    this.getProductionLines(true, true);
  }

  toggleFormModal = () =>
    this.setState({
      showFormModal: !this.state.showFormModal,
      serverResponse: undefined,
      editItem: {
        id: '',
        code: '',
        products: undefined,
        workstations: undefined
      },
    });


  getProductionLines = async (reset: boolean, showLoading: boolean) => {
    if (showLoading) {
      this.setState({ isLoading: true, showFormModal: false });
    }
    else this.setState({ isLoading: false, showFormModal: false });

    try {
      const data: any = await productionLineService.listAll(this.unit);
      const dataTableCreate: any = [];
      data.map((item: IProductionLine) => {
        dataTableCreate.push({
          id: item.id,
          code: item.code,
          createdAt: item.createdAt,
          products: item.products,
          workstations: item.workstations,
          action: true
        })
      })

      this.setState({
        isLoading: false,
        tableData: dataTableCreate,
      });
    } catch (error) {
      console.warn(error);
      this.setState({
        isLoading: false,
      });
    }
  }

  openEditModal = async (editItem: IProductionLine) => {
    this.setState({
      editItem,
      showFormModal: true
    });
    console.log('edit item', this.state.editItem)
    this.props.form.setFieldsValue(
      {
        code: editItem.code,
      });
  };

  onSubmit = async () => {
    const { tableData, editItem } = this.state;

    const form = this.props.form;

    this.setState({ loadingRequest: true });

    await form.validateFields((err: any, values: any) => {
      if (err) {
        console.log("Has error");
        return;
      }
    });

    try {
      let nextTableData: IProductionLine[] = [];
      let values = await form.getFieldsValue();

      if (editItem && !!editItem.id) {
        let dataEdit: IProductionLine;

        dataEdit = {
          id: editItem.id,
          code: values.code
        }
        const response = await productionLineService.updateById(editItem.id, dataEdit, this.unit);
        const targetIndex = findIndex(
          tableData,
          (item: IProductionLine) => item.id === response.id,
        );
        nextTableData = tableData;
        if (nextTableData[targetIndex]) {
          nextTableData[targetIndex] = Object.assign(nextTableData[targetIndex], response);
        }
      } else {
        values = {
          id: Date.now(),
          ...values
        }

        const response = await productionLineService.create(values, this.unit);
        nextTableData = [response, ...tableData];
      }
      const dataTableCreate: any = [];

      nextTableData.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          code: item.code,
          products: item.products,
          workstations: item.workstations,
          action: true
        })
      })

      this.setState({ loadingRequest: false, isLoading: false, showFormModal: false, tableData: dataTableCreate });
      console.log('NEW TABLE', this.state.tableData)

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("form.filter.errors.register"), error);
      this.setState({ loadingRequest: false });
    } finally {
    }
  };

  deleteProductionLine = async (id: string) => {
    try {
      // TODO: confirmar com Modal
      const { tableData } = this.state;
      const nextTableData = tableData.filter((item: IProductionLine) => item.id !== id);
      this.setState({
        isLoading: false,
        tableData: nextTableData,
      });
      await productionLineService.deleteById(id, this.unit);
    } catch (e) {

      console.error(e);
    }
  };

  searchData = async (event: any) => {

    let searchTableData: IProductionLine[] = [];
    const SearchValue = event === '' ? false : event.target.find.value;
    await this.setState({
      search: SearchValue,
      isLoading: true,
    })

    if (!SearchValue) {
      this.getProductionLines(true, false);
    }
    try {
      _.some(this.state.tableData, (o: any) => {
        console.log(_.includes(o.name, SearchValue))
        if (_.includes(o.name, SearchValue) || _.includes(o.code, SearchValue)) {
          searchTableData.push(o)
        }
      })
      await this.setState({
        isLoading: false,
        tableData: searchTableData
      })
    }
    catch (err) {
      console.log(err)
    }
  }

  formatProductionLineDataToTable = (productionLine: IProductionLine[]) => {
    const nextData: any[] = [];

    productionLine.map((productionLineItems: IProductionLine) => {

      let linkProduct =
        <Col >
          <a
            href="#"
            onClick={() => this.toggleProductModal(productionLineItems.id, productionLineItems.products)}
          >
            {I18n.l('table.productionLine.linkProducts')}
          </a>
          {productionLineItems.products === undefined &&
            <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" className={"goepik-small-left-margin"} />
          }
        </Col>;

      let linkWorkstation =
        <Col >
          <a
            href="#"
            onClick={() => this.toggleWorkstationModal(productionLineItems.id, productionLineItems.workstations)}
          >
            {I18n.l('table.productionLine.linkWorkstation')}
          </a>
          {productionLineItems.workstations === undefined &&
            <Avatar style={{ backgroundColor: '#D93838' }} icon="exclamation" className={"goepik-small-left-margin"} />
          }
        </Col>;
      nextData.push({
        id: productionLineItems.id,
        code: productionLineItems.code,
        products: linkProduct,
        workstations: linkWorkstation,
      })
    });
    return nextData;
  }

  //#region PRODUCT LINKED
  toggleProductModal = async (productionLineID?: string, productionLineProducts?: string[]) => {
    this.setState({
      showProductsModal: !this.state.showProductsModal,
      productionLineID: productionLineID || '',
      productionLineProducts: productionLineProducts || ['']
    });
    if (this.state.showProductsModal === true) {
      this.getAvailableProducts(true, true);
      this.getSavedProducts(true, true)
    }
    else { this.getProductionLines(true, false) }
  }

  onRemoveProduct = async (productId: string) => {
    this.setLoadingSavedProductData(productId, true);
    const productObj = this.getProductSavedObject(productId);

    try {
      await productionLineService.productRemove(this.state.productionLineID, productId, this.unit);
      this.setLoadingSavedProductData(productId, false);

      this.productRemoved(productId, productObj);
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.productUnlikedSuccess"));
    } catch (e) {
      this.setLoadingSavedProductData(productId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  productRemoved = async (id: string, productRemoved: any) => {
    const { availableProductsData, savedProductsData } = this.state;

    const newAvailableData: any[] = [...availableProductsData];
    newAvailableData.push(productRemoved);

    const productIndexToRemove = savedProductsData.findIndex((item: any) => item.id === id);
    let nextSavedData = [...savedProductsData];
    nextSavedData.splice(productIndexToRemove, 1);

    this.setState({
      savedProductsData: nextSavedData,
      availableProductsData: newAvailableData,
      savedProductsAmount: (this.state.savedProductsAmount - 1),
      availableProductsAmount: (this.state.availableProductsAmount + 1)
    });
    if (this.state.savedProductsData.length == 0 && this.state.savedProductsAmount > 0) {
    }

  }

  onAddProduct = async (productID: string) => {
    const { productionLineID } = this.state
    this.setLoadingAvailableProductData(productID, true);
    const productObj = this.getProductAvailableObject(productID);

    try {
      const response = await productionLineService.productAdd(productionLineID, productID, this.unit);
      console.log('VALOR DO REPONSE', response)

      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.productSuccess"));
      this.setLoadingAvailableProductData(productID, false);
      this.productAdded(productID, productObj);

    } catch (e) {
      this.setLoadingAvailableProductData(productID, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  productAdded = async (id: string, productToSave: any) => {
    const { availableProductsData, savedProductsData } = this.state;
    const newSaveData: any[] = [...savedProductsData];
    newSaveData.push(productToSave);

    const productIndexToRemove = availableProductsData.findIndex((item: any) => item.id === id);
    let nextAvailableData = [...availableProductsData];
    nextAvailableData.splice(productIndexToRemove, 1);

    this.LinkedRef.current.saveAvailableUserDone();

    this.setState({
      availableProductsData: nextAvailableData,
      savedProductsData: newSaveData,
      savedProductsAmount: (this.state.savedProductsAmount + 1),
      availableProductsAmount: (this.state.availableProductsAmount - 1)
    });
  }

  getProductAvailableObject(id: string) {
    const { availableProductsData } = this.state;
    let product = undefined;

    product = availableProductsData.find((item: any) => item.id === id);

    return product;
  }

  getProductSavedObject(id: string) {
    const { savedProductsData } = this.state;
    let product = undefined;

    product = savedProductsData.find((item: any) => item.id === id);

    return product;
  }

  setLoadingAvailableProductData = async (productId: string, loading: boolean) => {
    const { availableProductsData } = this.state;

    const product: any = availableProductsData.find((item) => {
      return item.id == productId;
    });
    const indexOf = availableProductsData.indexOf(product);

    const newProductData: any[] = [...availableProductsData];
    newProductData[indexOf].loading = loading;
    newProductData[indexOf].disabled = loading;

    this.setState({ availableProductsData: newProductData });
  }

  setLoadingSavedProductData = async (productId: string, loading: boolean) => {
    const { savedProductsData } = this.state;

    const product: any = savedProductsData.find((item) => {
      return item.id == productId;
    });
    const indexOf = savedProductsData.indexOf(product);

    const newProductData: any[] = [...savedProductsData];
    newProductData[indexOf].loading = loading;

    this.setState({ savedProductsData: newProductData });
  }

  onSearchAvailableProducts = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchAvailableProducts: SearchValue });
    this.getAvailableProducts(true, true);
  }

  onSearchSavedProducts = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchSavedProducts: SearchValue });

    this.getSavedProducts(true, true);
  }



  getAvailableProducts = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingAvailableProducts: showLoading,
      loadingMoreAvailableProducts: (!!loadingMore ? loadingMore : false)
    });
    if (reset) {
      this.setState({
        availableProductsData: [],
      });
    }

    try {
      const data: IPagination<Product> = await productsService.paging({
        unit: this.unit,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 10,
        offset: this.state.offset
      });

      // const dataProducts = await productsService.listAll();

      const dataTableCreate: any[] = [];

      for (const item of data.items) {
        const availableDataToTable = this.state.productionLineProducts.filter((x) => x === item.id)
        if (item.id !== availableDataToTable[0]) {
          dataTableCreate.push({
            id: item.id,
            code: item.code,
            name: item.name,
          })
        }
      }


      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.availableProductsData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      //console.log('new data', newDataTableCreate)
      this.setState({
        availableProductsData: newDataTableCreate,
        loadingAvailableProducts: false,
        loadingMoreAvailableProducts: false,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingAvailableProducts: false,
        loadingMoreAvailableProducts: false,
      });
    }
  };

  getSavedProducts = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingSavedProducts: showLoading,
      loadingMoreSavedProducts: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      this.setState({
        savedProductsData: [],
      });
    }

    try {

      const data: IPagination<Product> = await productsService.paging({
        unit: this.unit,
        to: undefined,
        from: undefined,
        search: this.state.search,
        limit: 10,
        offset: this.state.offset
      });
      // const data: any = await productsService.listAll();

      let dataTableCreate: any[] = [];

      for (const item of data.items) {
        //const availableDataToTable = this.state.productionLineProducts.filter((x) => x === dataItem.id)
        const availableDataToTable = this.state.productionLineProducts.filter((x) => x === item.id)
        if (item.id === availableDataToTable[0]) {
          dataTableCreate.push({
            id: item.id,
            code: item.code,
            name: item.name,
          })
        }
      }

      /*      
            data.map((item: Product) => {
              const availableDataToTable = this.state.productionLineProducts.filter((x) => x === item.id)
              if (item.id === availableDataToTable[0]) {
                dataTableCreate.push({
                  id: item.id,
                  code: item.code,
                  name: item.name,
                })
              }
            });
        */

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.savedProductsData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        savedProductsData: newDataTableCreate,
        loadingSavedProducts: false,
        loadingMoreSavedProducts: false,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingSavedProducts: false,
        loadingMoreSavedProducts: false,
      });
    }
  };

  loadMoreAvailableProducts = () => {
    this.getAvailableProducts(false, false, true);
  }

  loadMoreSavedProducts = () => {
    this.getSavedProducts(false, false, true);
  }
  //#endregion PRODUCT LINKED

  //#region WORKSTATIONS LINKED
  toggleWorkstationModal = async (productionLineID?: string, productionLineWorkstations?: string[]) => {
    this.setState({
      showWorkstationModal: !this.state.showWorkstationModal,
      productionLineID: productionLineID || '',
      productionLineWorkstations: productionLineWorkstations || ['']
    });
    console.log('productss', this.state.productionLineWorkstations)

    if (this.state.showWorkstationModal === true) {
      this.getAvailableWorkstations(true, true);
      this.getSavedWorkstations(true, true)
    }
    else { this.getProductionLines(true, false) }
  }

  onRemoveWorkstation = async (workstationsId: string) => {
    this.setLoadingSavedWorkstationData(workstationsId, true);
    const workstationObj = this.getWorkstationSavedObject(workstationsId);

    try {
      await productionLineService.workstationRemove(this.state.productionLineID, workstationsId, this.unit);
      this.setLoadingSavedWorkstationData(workstationsId, false);

      this.workstationRemoved(workstationsId, workstationObj);
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.workstationUnlikedSuccess"));
    } catch (e) {
      this.setLoadingSavedProductData(workstationsId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  workstationRemoved = async (id: string, workstationRemoved: any) => {
    const { availableWorkstationsData, savedWorkstationsData } = this.state;

    const newAvailableData: any[] = [...availableWorkstationsData];
    newAvailableData.push(workstationRemoved);

    const workstationIndexToRemove = savedWorkstationsData.findIndex((item: any) => item.id === id);
    let nextSavedData = [...savedWorkstationsData];
    nextSavedData.splice(workstationIndexToRemove, 1);

    this.setState({
      savedWorkstationsData: nextSavedData,
      availableWorkstationsData: newAvailableData,
      savedWorkstationsAmount: (this.state.savedWorkstationsAmount - 1),
      availableWorkstationsAmount: (this.state.availableWorkstationsAmount + 1)
    });
    if (this.state.savedWorkstationsData.length == 0 && this.state.savedWorkstationsAmount > 0) {
    }

  }

  onAddWorkstation = async (workstationsId: string) => {
    const { productionLineID } = this.state
    this.setLoadingAvailableWorkstationData(workstationsId, true);
    const workstationObj = this.getWorkstationAvailableObject(workstationsId);

    try {
      const response = productionLineService.workstationAdd(productionLineID, workstationsId, this.unit);
      console.log('VALOR DO REPONSE', response)

      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.workstationSuccess"));
      this.setLoadingAvailableWorkstationData(workstationsId, false);
      this.workstationAdded(workstationsId, workstationObj);

    } catch (e) {
      this.setLoadingAvailableWorkstationData(workstationsId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  workstationAdded = async (id: string, workstationToSave: any) => {
    const { availableWorkstationsData, savedWorkstationsData } = this.state;
    availableWorkstationsData
    const newSaveData: any[] = [...savedWorkstationsData];
    newSaveData.push(workstationToSave);

    const workstationIndexToRemove = availableWorkstationsData.findIndex((item: any) => item.id === id);
    let nextAvailableData = [...availableWorkstationsData];
    nextAvailableData.splice(workstationIndexToRemove, 1);

    this.LinkedRef.current.saveAvailableUserDone();

    this.setState({
      availableWorkstationsData: nextAvailableData,
      savedWorkstationsData: newSaveData,
      savedWorkstationsAmount: (this.state.savedWorkstationsAmount + 1),
      availableWorkstationsAmount: (this.state.availableWorkstationsAmount - 1)
    });
    if (this.state.availableWorkstationsData.length == 0 && this.state.availableWorkstationsAmount > 0) {
    }
  }

  getWorkstationAvailableObject(id: string) {
    const { availableWorkstationsData } = this.state;
    let workstation = undefined;

    workstation = availableWorkstationsData.find((item: any) => item.id === id);

    return workstation;
  }

  getWorkstationSavedObject(id: string) {
    const { savedWorkstationsData } = this.state;
    let workstation = undefined;

    workstation = savedWorkstationsData.find((item: any) => item.id === id);

    return workstation;
  }

  setLoadingAvailableWorkstationData = async (workstationId: string, loading: boolean) => {
    const { availableWorkstationsData } = this.state;

    const workstation: any = availableWorkstationsData.find((item) => {
      return item.id == workstationId;
    });
    const indexOf = availableWorkstationsData.indexOf(workstation);

    const newWorkstationData: any[] = [...availableWorkstationsData];
    newWorkstationData[indexOf].loading = loading;
    newWorkstationData[indexOf].disabled = loading;

    this.setState({ availableWorkstationsData: newWorkstationData });
  }

  setLoadingSavedWorkstationData = async (workstationId: string, loading: boolean) => {
    const { savedWorkstationsData } = this.state;

    const workstation: any = savedWorkstationsData.find((item) => {
      return item.id == workstationId;
    });
    const indexOf = savedWorkstationsData.indexOf(workstationId);

    const newWorkstationData: any[] = [...savedWorkstationsData];
    newWorkstationData[indexOf].loading = loading;

    this.setState({ savedWorkstationsData: newWorkstationData });
  }

  onSearchAvailableWorkstations = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchAvailableWorkstations: SearchValue });
    this.getAvailableWorkstations(true, true);
  }

  onSearchSavedWorkstations = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    this.setState({ searchSavedWorkstations: SearchValue });

    this.getSavedWorkstations(true, true);
  }



  getAvailableWorkstations = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingAvailableWorkstations: showLoading,
      loadingMoreAvailableWorkstations: (!!loadingMore ? loadingMore : false)
    });
    if (reset) {
      this.setState({
        availableWorkstationsData: [],
      });
    }

    try {
      const dataWorkstations = await workstationService.listAll(this.unit);

      const dataTableCreate: any[] = [];


      dataWorkstations.map((item: IWorkstation) => {
        const availableDataToTable = this.state.productionLineWorkstations.filter((x) => x === item.id)
        if (item.id !== availableDataToTable[0]) {
          dataTableCreate.push({
            id: item.id,
            code: item.code,
          })
        }
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.availableWorkstationsData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      this.setState({
        availableWorkstationsData: newDataTableCreate,
        loadingAvailableWorkstations: false,
        loadingMoreAvailableWorkstations: false,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingAvailableWorkstations: false,
        loadingMoreAvailableWorkstations: false,
      });
    }
  };

  getSavedWorkstations = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    this.setState({
      loadingSavedWorkstations: showLoading,
      loadingMoreSavedWorkstations: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      this.setState({
        savedWorkstationsData: [],
      });
    }

    try {
      const data: any = await workstationService.listAll(this.unit);

      let dataTableCreate: any[] = [];

      data.map((item: IWorkstation) => {
        const availableDataToTable = this.state.productionLineWorkstations.filter((x) => x === item.id)
        if (item.id === availableDataToTable[0]) {
          dataTableCreate.push({
            id: item.id,
            code: item.code,
          })
        }
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.savedWorkstationsData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      this.setState({
        savedWorkstationsData: newDataTableCreate,
        loadingSavedWorkstations: false,
        loadingMoreSavedWorkstations: false,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      this.setState({
        loadingSavedWorkstations: false,
        loadingMoreSavedWorkstations: false,
      });
    }
  };

  loadMoreAvailableWorkstations = () => {
    this.getAvailableWorkstations(false, false, true);
  }

  loadMoreSavedWorkstations = () => {
    this.getSavedWorkstations(false, false, true);
  }
  //#endregion WORKSTATIONS LINKED


  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      isLoading,
      showFormModal,
      tableData,
      serverResponse,
      search,
      loadingRequest,
      showProductsModal,
      showWorkstationModal,

      loadingAvailableProducts,
      loadingSavedProducts,
      savedProductsData,
      availableProductsData,
      searchAvailableProducts,
      searchSavedProducts,
      availableProductsAmount,
      savedProductsAmount,
      loadingMoreAvailableProducts,
      loadingMoreSavedProducts,

      availableWorkstationsAmount,
      availableWorkstationsData,
      loadingAvailableWorkstations,
      loadingMoreAvailableWorkstations,
      loadingMoreSavedWorkstations,
      loadingSavedWorkstations,
      savedWorkstationsAmount,
      savedWorkstationsData,
      searchAvailableWorkstations,
      searchSavedWorkstations,
    } = this.state;

    if (!!isLoading) {
      return (
        <Page>
          <AppContext.Consumer>
            {({ locale, activeUnitId }) => (
              this.setUnit(activeUnitId),
              <span>{I18n.l('common.loadingTable')}</span>
            )}
          </AppContext.Consumer>
        </Page>
      );
    }

    return (
      <AppContext.Consumer>
        {({ locale, theme }) => (
          <Page>
            <Wrapper>
              <Toolbar>
                <ToolbarItem>
                  <RegisterBtnComponent
                    onClick={this.toggleFormModal}
                    buttonText={I18n.l('common.register') + " " + I18n.l('labels.productionLine')}
                  />
                </ToolbarItem>
                <ToolbarItem>
                  <SearchComponent
                    onSubmit={this.searchData}
                    placeholder='form.placeholders.workstationSearch'
                    defaultValue={search}
                    buttonText='form.buttons.search'
                  />
                </ToolbarItem>
              </Toolbar>

              {tableData.length > 0 && (
                <div className={'goepik-component-tablesize'}>
                  <Table
                    columns={tableColumns}
                    data={this.formatProductionLineDataToTable(tableData)}
                    onEdit={this.openEditModal}
                    onDelete={this.deleteProductionLine}
                    noPagination={true}
                    showConfirmationModal={false}
                  />
                </div>
              )}
              {tableData.length === 0 && <p>{locale && I18n.l('common.noResult')}</p>}
              {showFormModal && (
                <Modal destroyOnClose={true} onCancel={this.toggleFormModal} visible={showFormModal} closable={false} footer={false}>
                  <ModalTitle>{I18n.l('form.titles.productionLineForm')}</ModalTitle>
                  <ModalContent>
                    <Form hideRequiredMark={true}>
                      <FormItem
                        label={I18n.l('form.labels.codeProductionLine')}
                        colon={false}
                      >
                        {getFieldDecorator('code', {
                          rules: [
                            { required: true, message: I18n.l('form.validation.field.required'), whitespace: false },
                            {
                              min: 3, message: I18n.l('form.validation.text.min')
                            },
                            {
                              max: 15, message: I18n.l('form.validation.text.max')
                            }],
                          initialValue: ''
                        }
                        )(
                          <Input />
                        )}
                      </FormItem>
                    </Form>
                    <Row className="goepik-component-padding" type="flex" align='middle' justify="end">
                      <Button disabled={loadingRequest} className="main-button" style={{ fontWeight: 'bold' }} type="primary" size="large" ghost onClick={this.toggleFormModal}>
                        {I18n.l('common.cancel').toUpperCase()}
                      </Button>
                      <RegisterBtnComponent
                        loading={loadingRequest}
                        disabled={loadingRequest}
                        onClick={this.onSubmit}
                        buttonText={I18n.l('common.save')}
                      />
                    </Row>
                    {serverResponse && (
                      <ApiResponseDisplayer theme={theme} locale={locale} data={serverResponse} />
                    )}
                  </ModalContent>
                </Modal>
              )}
              {/* MODAL LINKED PRODUCTS */}
              {showProductsModal && (
                <LinkedComponent
                  title={I18n.l('table.productionLine.linkProducts')}
                  titleAvailable={I18n.l('table.productionLine.availableProducts')}
                  titleLinked={I18n.l('table.productionLine.linkedProducts')}
                  titleLoading={I18n.l('productionLine.loadingSavedProducts')}
                  showModal={showProductsModal}
                  onToggleFormModal={() => this.toggleProductModal()}
                  serverResponse={serverResponse}
                  onItemRemoved={this.onRemoveProduct}
                  onItemSelected={this.onAddProduct}
                  loadingAvailableData={loadingAvailableProducts}
                  loadingSavedData={loadingSavedProducts}
                  availableData={availableProductsData}
                  savedData={savedProductsData}
                  availableTableColumns={productsAvailableTableColumns}
                  savedTableColums={productsSavedTableColumns}
                  onSearchAvailable={this.onSearchAvailableProducts}
                  onSearchSaved={this.onSearchSavedProducts}
                  searchAvailableValue={searchAvailableProducts}
                  searchSavedValue={searchSavedProducts}
                  showMoreAvailableData={availableProductsAmount > availableProductsData.length}
                  showMoreSavedData={savedProductsAmount > savedProductsData.length}
                  onLoadMoreAvailableData={this.loadMoreAvailableProducts}
                  onLoadMoreSavedData={this.loadMoreSavedProducts}
                  loadingMoreAvailableData={loadingMoreAvailableProducts}
                  loadingMoreSavedData={loadingMoreSavedProducts}
                  ref={this.LinkedRef}
                />
              )}
              {/* MODAL LINKED WORKSTATIONS */}
              {showWorkstationModal && (
                <LinkedComponent
                  title={I18n.l('table.productionLine.linkWorkstation')}
                  titleAvailable={I18n.l('table.productionLine.availableWorkstations')}
                  titleLinked={I18n.l('table.productionLine.linkedWorkstations')}
                  titleLoading={I18n.l('productionLine.loadingSavedWorkstations')}
                  showModal={showWorkstationModal}
                  onToggleFormModal={() => this.toggleWorkstationModal()}
                  serverResponse={serverResponse}
                  onItemRemoved={this.onRemoveWorkstation}
                  onItemSelected={this.onAddWorkstation}
                  loadingAvailableData={loadingAvailableWorkstations}
                  loadingSavedData={loadingSavedWorkstations}
                  availableData={availableWorkstationsData}
                  savedData={savedWorkstationsData}
                  availableTableColumns={workstationsAvailableTableColumns}
                  savedTableColums={workstationsSavedTableColumns}
                  onSearchAvailable={this.onSearchAvailableWorkstations}
                  onSearchSaved={this.onSearchSavedWorkstations}
                  searchAvailableValue={searchAvailableWorkstations}
                  searchSavedValue={searchSavedWorkstations}
                  showMoreAvailableData={availableWorkstationsAmount > availableWorkstationsData.length}
                  showMoreSavedData={savedWorkstationsAmount > savedWorkstationsData.length}
                  onLoadMoreAvailableData={this.loadMoreAvailableWorkstations}
                  onLoadMoreSavedData={this.loadMoreSavedWorkstations}
                  loadingMoreAvailableData={loadingMoreAvailableWorkstations}
                  loadingMoreSavedData={loadingMoreSavedWorkstations}
                  ref={this.LinkedRef}
                />
              )}
            </Wrapper>
          </Page>
        )}
      </AppContext.Consumer>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
        
  .field-title{
    font-weight: bold;
  }
  .ant-form-item label{
    font-weight: bold;
  }
`;

const Toolbar = styled.div`
  flex: 0;
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 40px;
  width: 100%;
`;

const ToolbarItem = styled.div`
  flex: 1;
  margin-left: 50px;
              
  &:first-of-type {
      flex: 0;
    margin-left: 0;
  }
  `;

const ModalTitle = styled.h3`
  font-size: 22px;
`;

const ModalContent = styled.div`
    width: 100%;
                
    .field-title{
        font-weight: bold;
    }
            
    .ant-form-item{
        margin-bottom: 8px;
    }
    .ant-form-item-label label{
        font-weight: normal;             
    }
    `;

export const ProductionLineComponent = Form.create()(ProductionLineContainer);